import React from 'react'
import { connect } from 'react-redux'
import { Tooltip, IconButton } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import { openEdicionDetalleBodegaDialog } from '../../actions/PlanDeEmbarqueActions'

function EdicionPlanDeEmbarqueBodega (props) {
  const { detalle } = props

  const handleOpen = () => {
    props.openEdicionDetalleBodegaDialog(detalle.fechaDeReferencia, detalle.bodega, detalle.buque, detalle.paisDestino)
  }

  return (
    <Tooltip title={'Editar'}>
      <IconButton onClick={handleOpen}>
        <EditIcon />
      </IconButton>
    </Tooltip>
  )
}

const mapActionsToProps = {
  openEdicionDetalleBodegaDialog
}

const withRedux = connect(null, mapActionsToProps)

export default withRedux(EdicionPlanDeEmbarqueBodega)
